import actionTypes from "../actionTypes";


const fetchAvailable = () => {
  return {
    type: actionTypes.plan.FETCH_AVAILABLE
  };
}

const fetchAvailableOk = (data) => {
  return {
    type: actionTypes.plan.FETCH_AVAILABLE_OK,
    data: data
  };
}

const fetchAvailableError = (error) => {
  return {
    type: actionTypes.plan.FETCH_AVAILABLE_ERROR,
    error: error
  };
}

export const planActions = {
  fetchAvailable,
  fetchAvailableOk,
  fetchAvailableError
};